import { Popover, Whisper, Button } from 'rsuite';
import { Checkbox, Divider } from 'antd';
import { Row, Col, Container } from "react-bootstrap";
import { useMemo, useState, useEffect, useCallback } from "react";

export default function PackageFullBody({data: { label, options, parent, last_used, package_type_using }, onChangeItemFullBody, index, indexParent}) {
  const [checkAll, setCheckAll] = useState(false);
  const [packageSubs, setPackageSubs] = useState([]);

  const selectedItems = useMemo(() => {
    return packageSubs.filter(x => x.isSelect);
  }, [packageSubs]);

  const updateStateAfterChange = useCallback((list) => {
    let intend_time = 0;
    let new_service = [];

    if (list.length === packageSubs.length && !package_type_using) {
      new_service.push({
        id: parent.value,
        product_name: parent.product_name,
        package_code: parent.package_code,
        left_use: parent.left_use,
        price: 0,
        product_id: parent.product_id,
        category_id: parent.product.category_id,
        parent_package: parent.parent_package
      });
      intend_time = Number(parent.time) + 5;
    } else {
      list.forEach(item => {
        new_service.push({
          id: item.value,
          product_name: item.product_name,
          package_code: item.package_code,
          left_use: item.left_use,
          price: 0,
          product_id: item.product_id,
          category_id: item.product.category_id,
          parent_package: item.parent_package
        });
        intend_time += Number(item.time);
      });

      if (list.length > 0) intend_time += 5;
    }

    intend_time = Math.min(intend_time, 60);
    onChangeItemFullBody(index, {product_ids: new_service, intend_time}, indexParent);

  }, [packageSubs, package_type_using, parent, onChangeItemFullBody, index, indexParent]);

  useEffect(() => {
    updateStateAfterChange(selectedItems);
  }, [selectedItems]);

  const handleToggle = (i) => {
    const updated = [...packageSubs];
    updated[i].isSelect = !updated[i].isSelect;
    setPackageSubs(updated);
  };

  const handleCheckAll = () => {
    const newVal = !checkAll;
    setCheckAll(newVal);

    const updated = packageSubs.map(x => ({
      ...x,
      isSelect: x.disabled ? false : newVal
    }));

    setPackageSubs(updated);
  };

  useEffect(() => {
    setPackageSubs(options.map(x => ({ ...x })));

    const allSelected = options.length > 0 && options.every(x => x.isSelect);
    setCheckAll(allSelected);
  }, [options]);

  return (
    <Whisper trigger="click" placement="top"
      speaker={(props, ref) => { const { className, left, top, style, arrowOffsetLeft, arrowOffsetTop, ...restProps } = props;
        return (
          <Popover
            ref={ref}
            className={className}
            style={{ ...style, left, top, maxWidth: "80vw", width: "550px" }}
            title={label}
            {...restProps}
          >
            <Checkbox checked={checkAll} onChange={handleCheckAll}>Chọn tất cả</Checkbox>
            <Divider />
            <Container fluid>
              <Row>
                {packageSubs.map((x, i) => (
                  <Col xs={12} md={6} key={i} className="mb-10">
                      <Checkbox
                        checked={x.isSelect}
                        disabled={x.disabled}
                        onChange={() => handleToggle(i)}
                      >
                      {x.product_name}
                      </Checkbox>
                  </Col>
                ))}
              </Row>
            </Container>
          </Popover>
        )}}
      >
      <Button appearance="subtle" className={selectedItems.length > 0 ? "success-full" : ""} style={{width: '100%', textAlign: "left"}}>
        {label}
      </Button>
    </Whisper>
  );
}